import Vue from 'vue'
// 引入element ui
import {
  Pagination,
  Badge,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Autocomplete,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  OptionGroup,
  Button,
  Table,
  TableColumn,
  Popover,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Icon,
  Row,
  Col,
  Upload,
  Carousel,
  CarouselItem,
  Cascader,
  Transfer,
  Container,
  Header,
  Aside,
  Main,
  Link,
  Divider,
  Result,
  Empty,
  Rate,
  DatePicker,
  Progress,
  Image,
  Drawer,
  Scrollbar,
  Slider,
  InputNumber,
  ColorPicker,
  TimePicker,
  CascaderPanel,
  Card,
  Loading,
  MessageBox,
  Message,
  Notification
} from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css'
import zhLang from 'element-ui/lib/locale/lang/zh-CN' // 引入官方的中文国际化
import locale from '@/assets/locale/cn' // 引入自己的

Vue.use(
  {
    locale: { ...zhLang, ...locale }, // 使用本地的locale去替代官方的zhLange
  })
Vue.use(InputNumber);
Vue.use(Slider);
Vue.use(Scrollbar);
Vue.use(Result);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Cascader);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Empty);
Vue.use(Rate);
Vue.use(DatePicker);
Vue.use(Progress);
Vue.use(Image)
Vue.use(Drawer)
Vue.use(ColorPicker)
Vue.use(TimePicker)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Badge)
Vue.use(CascaderPanel)
Vue.use(Card)

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
